/**
 * Minimal JWT payload reader. Only used to schedule a refresh *before* the access
 * token expires — the backend remains the sole authority on token validity.
 */
export function getTokenExpiryMs(token: string | null | undefined): number | null {
  const payload = token?.split('.')[1];
  if (!payload) {
    return null;
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const claims = JSON.parse(window.atob(padded)) as { exp?: unknown };
    return typeof claims.exp === 'number' ? claims.exp * 1000 : null;
  } catch {
    return null;
  }
}
